module.exports = __webpack_public_path__ + "static/vulnerabilities-in-dependencies-4887b1e43cd1185a16cf1b7347a4a782.png";